export const SELECT = 'SELECT_CRITICAL_CARE';
export const DEFAULT = 'DEFAULT_CRITICAL_CARE';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_CRITICAL_CARE';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_CRITICAL_CARE';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_CRITICAL_CARE';
export const SELECT_ANOREXIA = 'SELECT_ANOREXIA';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
